 /*================ Content Factory
  ========================================*/
  angular
    .module('vppApp')
    .factory('contentFactory', contentFactory);

    contentFactory.$inject = ['$http', '$rootScope', '$log', 'vppConfig', '$state', 'VarientService'];

    function contentFactory($http, $rootScope, $log, vppConfig, $state, VarientService){
      return function(){
        var noVarient = "";
        var thisVarient;
        var getVarient = VarientService.getVarientName();

        /* === comment when varient needs to work ===*/
        thisVarient = noVarient;
        /* === uncomment when varient needs to work, like in soty ===*/
        // if (getVarient && ($state.current.name === 'promote.main' && getVarient)) {
        //  thisVarient = "-" + getVarient;
        // } else {
        //  thisVarient = noVarient;
        // }
        var Url = vppConfig.contentPath + "content-" + $state.current.name + thisVarient +".json";
        var promise = $http.get(Url).then(function successCallback(data){
        return data;
      }, function errorCallback (data){
        return data;
      });

      return promise;
      };

  }